module.exports = __webpack_public_path__ + "img/1bagelstudio_logo_white.c5caf6a2.svg";